import { useState } from 'react'
// Caller keys include user, session and ticket. Content never enters URLs or shared query caches.
export function useSupportDraft(scope: string) {
  const key = `support-draft:${scope}`
  const [body, setBody] = useState(() => { try { return sessionStorage.getItem(key) || '' } catch { return '' } })
  function update(value: string) {
    setBody(value)
    try { if (value) sessionStorage.setItem(key, value); else sessionStorage.removeItem(key) } catch { /* The draft remains in memory when storage is unavailable. */ }
  }
  return [body, update] as const
}
export function clearSupportDrafts() {
  try { for (const key of Object.keys(sessionStorage)) if (key.startsWith('support-draft:') || key.startsWith('admin-command:support-')) sessionStorage.removeItem(key) } catch { /* Storage may be unavailable. */ }
}
